import {Observable, of, Subject} from 'rxjs';


export interface GdkCacheContent {
  expiry: number;
  value: any;
}


export class GdkCacheService {
  private cache: Map<string, GdkCacheContent> = new Map<string, GdkCacheContent>();
  readonly DEFAULT_MAX_AGE: number = 30000000;


  get(key: string): Observable<any> | Subject<any> {

    if (this.hasValidCachedValue(key)) {
      console.log(`%cGetting from cache ${key}`, 'color: green');
      return of(this.cache.get(key).value);
    }
    return of(null);
  }

  set(key: string, value: any, maxAge: number = this.DEFAULT_MAX_AGE): void {
    this.cache.set(key, { value: value, expiry: Date.now() + maxAge });
  }

  has(key: string): boolean {
    return this.cache.has(key);
  }


  private hasValidCachedValue(key: string): boolean {
    if (this.cache.has(key)) {
      if (this.cache.get(key).expiry < Date.now()) {
        this.cache.delete(key);
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
}
